import * as React from 'react';
import _ from 'lodash';
import { Paper, makeStyles, Grid, TextField, Button } from '@material-ui/core';
import { SelectWithLabel } from '../../utils/selectWithLabel'
import { useDispatch, useSelector } from 'react-redux';
import { sendText, setTextStatus } from '../../store/departures'
import { getTemplateChoices } from './utils/templateChoices'
import { MessageStatusDisplay } from './utils/messageStatusDisplay'
import { SelectWithLabelAndCheckbox } from '../../utils/selectWithLabelAndCheckbox';

let screenWidth = window.innerWidth

const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
  paper: {
    position: 'absolute',
    width: screenWidth <= 450 ? '90%' : '50%',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    // padding: theme.spacing(2, 4, 3),
  },
  sendingPaper: {
    minWidth: '20%',
    minHeight: '5%',
    position: 'absolute',
    padding: '10px',
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    marginTop: '12%'
  }
}));

export const TextModal = (props) => {
  const passengers = props.paxInfo && props.paxInfo.passengers ? props.paxInfo.passengers : []
  const route = `${'from ' + props.paxInfo.flightStatusLeg.departure.airport.name || ' '} ${'to ' + props.paxInfo.flightStatusLeg.arrival.airport.name || ' '}`
  // TODO // flightNum prefix should be dynamic instead of 'AN'
  const flightNum = `AN${props.paxInfo.flightStatus.flightNumber}`
  const classes = useStyles()
  const textStatus = useSelector(state => state.entities.departures.textStatus)
  const [message, setMessage] = React.useState('')
  //old code
  // const [recipients, setRecipients] = React.useState(passengers.length ? ['All'] : [''])
  const [recipients, setRecipients] = React.useState([])
  const [template, setTemplate] = React.useState('')
  const dispatch = useDispatch()
  const date = useSelector(state => state.entities.departures.departureDate);

  // TODO // this can be made more dynamic when we introduce more companies
  let templateChoices = getTemplateChoices('AN', 'text', route)

  // NOTE // formatting choices for SelectWithLabel and for the api call
  let passengerChoices = []
  let uniquePhones = []
  let formattedPassengerChoices = []
  if (passengers.length) {
    // NOTE // information being sent to api/texting
    passengerChoices = passengers && passengers.length ? passengers.map(p => {
      let firstName = p.profile.firstName
      let lastName = p.profile.lastName
      let formattedFirstName = firstName ? firstName[0] + firstName.slice(1, firstName.length).toLowerCase() : ''
      let formattedLastName = lastName ? lastName[0] + lastName.slice(1, lastName.length).toLowerCase() : ''
      let rloc = p.reservation.locator
      let phone = p.reservation.bookingInformation.contactInformation.phoneNumber
      if (firstName && lastName && rloc && phone && !uniquePhones.includes(phone)) {
        let label = `${formattedFirstName} ${formattedLastName} (${rloc})`
        let value = {name: `${firstName} ${lastName}`, phone: phone, rloc: rloc}
        if (label && value) {
          uniquePhones.push(phone)
          return {value: value, label: label}
        }
      }
    }).filter(n => n) : ['']
    // NOTE // for value to be read in SelectWithLabel value can't be an object
    // NOTE // adding in the 'All' option here so it isn't considered a passenger
    formattedPassengerChoices = [{label: 'All', value: 'All'}].concat(passengerChoices.map(p => {return {label: p.label, value: p.value.name || 'All'}}))
  }



  const handleTemplate = (e) => {
    setMessage(e.target.value)
    setTemplate(e.target.value)
  }

  
  const handleRecipients = (event) => {
    const {
      target: { value },
    } = event;
    if(value.includes('All')){
      setRecipients([])
      setRecipients(formattedPassengerChoices.map((e)=>e.value))
    }else{
      setRecipients(
        typeof value === 'string' ? value.split(',') : value,
      );
    }
   
  };
  const handleMessage = (e) => {
    setMessage(e.target.value)
  }

  // NOTE // formatting passenger(s) to set up textStatus and sendText
  const handleSend = () => {
    let passengerDetails
   
    if (recipients.includes('All')) {
      // NOTE // sending all the passenger details and removing labels
      passengerDetails = passengerChoices.map(fpc => fpc.value)
      console.log('all pax: ', passengerDetails)
      if (passengerDetails && passengerDetails.length) {
        dispatch(setTextStatus(passengerDetails))
        dispatch(sendText(message, flightNum, passengerDetails, date))
      }
    }
    else {
      passengerDetails = passengerChoices.filter(pc => recipients.includes(pc.value.name))
      console.log('single pax: ', passengerDetails)
      if (passengerDetails) {
        const passengerDetailValues = passengerDetails.map(p => p.value)
        console.log(passengerDetailValues)
        dispatch(setTextStatus(passengerDetailValues))
        dispatch(sendText(message, flightNum, passengerDetailValues, date))
      }
    }
  }

  return (
    <Grid container justify="center" alignContent="center" style={{marginTop: '10%'}}>
      { (textStatus && textStatus !== null) ?
        // NOTE // what shows up when sending a text
        <Paper className={classes.sendingPaper}>
          <Grid container item xs={12} justify="center">
            <MessageStatusDisplay status={textStatus} type={'phone'} />
          </Grid>
          <Grid container item xs={12} justify="center">
            <Button variant="contained" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
          </Grid>
        </Paper> :
        <Paper className={classes.paper}>
          <Grid container item xs={12} justify="center" style={{fontSize: '60px', width: '100%', height: '20%', borderBottom: '2px solid rgba(201, 195, 195, 1)', backgroundColor: 'rgb(63, 81, 181, 1)'}}>
            <h5 style={{margin: '0px', paddingTop: '12px'}}>Text Pax</h5>
          </Grid>
          <Grid container item xs={12} style={{paddingTop: '5px', paddingBottom: '5px', borderBottom: '2px solid rgba(201, 195, 195, 1)'}}>
            <Grid item xs={2}></Grid>
            <Grid container item lg={4} xs={12} justify="center">
              <SelectWithLabel defaultVal={template} handleChange={(e) => {handleTemplate(e)}} inputLabel={'Template'} items={templateChoices} />
            </Grid>
            <Grid item xs={1}></Grid>
            <Grid container item lg={4} xs={12} justify="center">
              <SelectWithLabelAndCheckbox defaultVal={recipients} handleChange={handleRecipients} multiple={true} inputLabel={'Recipients'} items={formattedPassengerChoices} />
            </Grid>
          </Grid>
          <Grid container item xs={12} style={{paddingTop: '3em', paddingLeft: '5em', paddingRight: '5em', height: '60%' }}>
            <TextField
              id="filled-multiline-static"
              label="Message"
              multiline
              rows={12}
              value={message}
              onChange={(e) => {handleMessage(e)}}
              variant="filled"
              style={{width: '100%', height: 'inherit'}}
            />
          </Grid>
          <Grid container style={{marginBottom: '5%', marginTop: '5%'}}>
            <Grid style={{textAlign: 'center'}} item lg={7} xs={12}>
              <p style={{color: 'red', fontSize: 'large', marginTop: '5px'}}>
                {!passengers || !recipients || !message.length ? 'You need recipients and a message to send' : ''}
              </p>
            </Grid>
            <Grid item xs={3} lg={1}></Grid>
            <Grid item xs={3} lg={1} style={{marginRight: '5%'}}>
              { passengers && recipients && message.length ? <Button onClick={() => {handleSend()}} variant="contained" style={{backgroundColor: '#03fc66'}}>Send</Button> : <Button variant="contained" disabled style={{backgroundColor: '#03fc66'}}>Send</Button> }
            </Grid>
            <Grid item xs={3} lg={1}>
              <Button variant="contained" onClick={() => {props.closeModal(false)}} style={{backgroundColor: '#eb494e'}}>Close</Button>
            </Grid>
          </Grid>
        </Paper>
      }
    </Grid>
  )
}